import { reset } from 'src/store'

const loggedInStates = () => {
  return [
    'fileThumbnails'
  ]
}

const defaultStates = () => {
  return {
    fileThumbnails: {}
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setThumbnail (state, { id, thumbnail }) {
      if (!thumbnail) {
        return
      }

      // Add cached thumbnail to cache with current timestamp to avoid using cached version after
      //  a certain amount of time
      state.fileThumbnails[id] = {
        time: Date.now(),
        thumbnail
      }
    }
  },
  actions: {
    thumbnail ({ commit, state }, { id, thumbnail }) {
      commit('setThumbnail', { id, thumbnail })

      return (state.fileThumbnails[id]?.thumbnail) || null
    }
  },
  getters: {
    getThumbnails: state => state.fileThumbnails,
    thumbnail: state => (id) => {
      const cachedVal = state.fileThumbnails[id] || null
      // If cached img doesn't exist, return null
      if (!cachedVal) {
        return null
      }

      // Use the cached image for up to 48 hours after entering the store.
      // After this time, it is invalid and will return null
      const HR48 = 48 * 60 * 60 * 1000
      if (cachedVal && cachedVal.time >= (Date.now() - HR48)) {
        return cachedVal.thumbnail || null
      }

      return null
    }
  }
}
